import React, {useEffect, useRef, useState} from 'react';
import {FormPageRoot, Img_CreateAlbum_FormDialog, ThemedButton} from "../../../index";
import {useTheme} from "../../../../common/ProjectThemeProvider";
import {
    checkNull,
    checkNullArr,
    checkNullJson,
    checkNullStr,
    convertReadableSizeToBytes,
    createTimeout,
    dropJsonListDuplicates,
    generateUniqueString,
    getArrIndexValue,
    getArrLen,
    getCurrUrlParamValue,
    getJsonValue,
    getJsonValueFromNestedKeys,
    isBoolTrue,
    isJsonValueTrue,
    parseInteger,
    trim
} from "../../../../common/fusion-ui/utils/ReactUtils";
import {focusFormIdElement, getSubdomainSessionData, isCurrUserRoleAdmin, printError, printLog, sendRequest} from "../../../utils/AppUtils";
import {useToast} from "../../../../common/fusion-ui/provider/ToastProvider";
import {EventFormParticipantTypes as PARTICIPANT_TYPES, INPUT_FILE_MAX_SIZE, ModuleFieldsData, ModuleRouteUrls, Modules, ReqUrls,} from "../../../config/AppConfig";
import {Avatar, Checkbox, Flexbox, GridBox, Label, MsgBox, NullMsgLabel, RadioToggle, SearchableCheckboxList, Select} from "../../../../common/fusion-ui";
import {Constants, CssVariant, Messages} from "../../../../common/fusion-ui/config/FusionConfig";
import {useInternetStatus} from "../../../../common/fusion-ui/hook";
import {UnderMaintenance, UnderMaintenanceMsg} from "../../../../common/CommonConfig";

const Image_AddEdit_FormPage = React.memo(({
                                               updateOnly,
                                           }) => {
    const TAG = "Image_AddEdit_FormPage";

    const moduleName = Modules.Images;
    const mf = ModuleFieldsData[moduleName];
    const NAME_KEY = 'name';

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline, internetCheckingMsg} = useInternetStatus();

    const FOCUS_DELAY = 2000;
    const MAX_IMG_COUNT = 15;

    const Fields = {
        updateRecordId: 'updateRecordId',

        canShowAddForm: 'canShowAddForm',
        isUpdateFormDataFetched: 'isUpdateFormDataFetched',

        imagesLoading: 'imagesLoading',

        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        participantsLoading: 'participantsLoading',
        resetParticipantsList: 'resetParticipantsList',
        participantsLoaded: 'participantsLoaded',
        participantsLoadingMsg: 'participantsLoadingMsg',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',

        currParticipantGroupId: 'currParticipantGroupId',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',

        albums: 'albums',
        selectedAlbum: 'selectedAlbum',
        showAlbumLoading: 'showAlbumLoading',

        openCreateAlbumDialog: 'openCreateAlbumDialog',
    };
    const [fieldsData, setFieldsData] = useState({});
    // const [formData, setFormData] = useState(Image_AddEdit_FormPage_Data);
    const [formData, setFormData] = useState({});
    const [formFieldsMsgs, setFormFieldsMsgs] = useState({});
    const imgChooserInputRef = useRef(null);

    useEffect(() => {
        // setFormData({});
        const recordId = getCurrUrlParamValue('id');
        // log('useEffect.updateOnly:', isUpdateMode(), 'updateRecordId:', recordId);

        if (!checkNullStr(getFormField(mf.notificationTo))) {
            updateFormField(mf.notificationTo, true);
            if (!isUpdateMode()) {
                updateFormField(mf.participantDisplayType, PARTICIPANT_TYPES.membersOnly);
            }
        }
        if (isUpdateMode()) {
            fetchEditModeData(recordId);
        } else {
            fetchParticipantList([], true);
        }
    }, [updateOnly]);

    return (<>
        <FormPageRoot
            tag={TAG}
            moduleName={moduleName}
            addPageTitle={getTabTitle()}
            editPageTitle={getTabTitle()}
            updateOnly={isUpdateMode()}
            isDataLoading={getField(Fields.isDataLoading)}
            isDataFound={getField(Fields.isDataFound)}
            dataLoadingMsg={getField(Fields.dataLoadingMsg)}>
            <div>
                {/*album*/}
                <Flexbox className={''} justifyAt={'between'} alignAt={'center'}>
                    {/*album-select*/}
                    <Select
                        id={mf.albumName.column}
                        wrapperClassName={`w-100`}
                        className={`w-100 rounded-3 py-2`}
                        innerWrapperClassName={'w-100'}
                        labelClassName={'w-100 text-input-label'}
                        variant={'primary'}
                        justifyAt={'start'}
                        // style={{height: '32px'}}
                        labelColor={theme.text40}
                        wrap={'wrap'}
                        label={'Select an album'}
                        placeholder={'Select an album'}
                        textKey={'text'}
                        idKey={'id'}
                        required={true}
                        options={getField(Fields.albums, [])}
                        defOption={getFormField(mf.albumId)}
                        showLoader={isFieldTrue(Fields.showAlbumLoading)}
                        showRefresh={true}
                        onRefresh={() => fetchAlbums()}
                        onChange={(e, text, value) => {
                            log('album.Select.onChange::text:', text, "value:", value);
                            updateFormField(mf.albumId, value);
                            updateFormField(mf.albumName, text);
                        }}
                    />

                    {/*create-album btn*/}
                    {isCurrUserRoleAdmin() && <ThemedButton
                        className={'rounded-2 w-auto px-2 py-1 text-nowrap fs-sm'}
                        text={'Create new album'}
                        outlined={true}
                        ml={3}
                        mt={3}
                        variant={theme.primaryBlue}
                        onClick={() => updateField(Fields.openCreateAlbumDialog, true)}
                    />}
                </Flexbox>

                {/*images*/}
                <div className={'mt-3'}>
                    {<input className={'d-none'}
                            ref={imgChooserInputRef}
                            type="file"
                            id={mf.imageList.column}
                            multiple={true}
                            accept={'.jpg, .jpeg, .png'}
                            onChange={(event) => {
                                try {
                                    const accept = '.jpg, .jpeg, .png';
                                    const maxSize = INPUT_FILE_MAX_SIZE;
                                    const files = event.target.files;

                                    //Max limit checkpoint
                                    if (getArrLen(Object.keys(files)) > MAX_IMG_COUNT) {
                                        toast(`Max limit: ${MAX_IMG_COUNT}!`, CssVariant.warning);
                                        return false;
                                    }

                                    if (checkNullArr(Object.keys(files))) {
                                        let alreadyImagesList = getFormField(mf.imageList);
                                        alreadyImagesList = checkNullArr(alreadyImagesList) ? alreadyImagesList : [];
                                        // log(`images.onChange.alreadyImagesList:`, alreadyImagesList);

                                        Object.keys(files).forEach(key => {
                                            const fileObj = files[key];
                                            const name = fileObj.name;
                                            let fileExt = (name + '').split('.').pop();
                                            fileExt = '.' + fileExt;
                                            const fileSizeBytes = fileObj.size;
                                            // log(`images.onChange[${key}].name:`, name, 'fileExt:', fileExt, 'fileSizeBytes:', fileSizeBytes, 'maxSize:', convertReadableSizeToBytes(maxSize));
                                            if (checkNull(fileObj)) {
                                                if (checkNullStr(maxSize) && fileSizeBytes > convertReadableSizeToBytes(maxSize)) {
                                                    // if (onSizeExceeded) onSizeExceeded(event, fileObj, fileSizeBytes);
                                                } else {
                                                    updateField(Fields.imagesLoading, true);
                                                    const reader = new FileReader();
                                                    reader.onload = () => {
                                                        const file = reader.result;
                                                        let fileName = (name + '').toLowerCase();
                                                        const acceptFormats = (accept + '').trim().toLowerCase().split(',')
                                                        //check-extensions
                                                        if (acceptFormats.some(format => fileName.endsWith((format + '').toLowerCase().trim()))) {
                                                            alreadyImagesList.push({
                                                                [mf.recordId.column]: generateUniqueString(alreadyImagesList.map(item => getJsonValue(item, mf.recordId.column))),
                                                                [mf.title.column]: file,
                                                                [mf.fileExt.column]: fileExt,
                                                            });
                                                            alreadyImagesList = dropJsonListDuplicates(alreadyImagesList, mf.title.column);
                                                            alreadyImagesList = dropJsonListDuplicates(alreadyImagesList, mf.recordId.column);
                                                            updateFormField(mf.imageList, alreadyImagesList);
                                                            // setAvatarImg(file);
                                                            // setErrorOccurred(false);
                                                        } else {
                                                            // setDefAvatar(defAvatarImg);
                                                            // setErrorOccurred(true);
                                                            // if (onInvalidFormat) onInvalidFormat(event, name);
                                                        }
                                                        updateField(Fields.imagesLoading, false);
                                                    };
                                                    reader.readAsDataURL(fileObj);
                                                }
                                            }
                                        });
                                    } else {
                                        toast("No images selected!", CssVariant.info);
                                    }
                                } catch (error) {
                                    logErr(`images.onChange.error:`, error);
                                }
                            }}
                    />}
                    <Flexbox className={''} justifyAt={'between'} alignAt={'center'}>
                        <Flexbox justifyAt={'start'} alignAt={'center'} wrap={''}>
                            {/*add-imgs*/}
                            <ThemedButton
                                className={'w-auto rounded-2 px-2 py-1 text-nowrap fs-sm'}
                                text={isImgListFound() ? `Select more images${getArrLen(getFormField(mf.imageList)) > MAX_IMG_COUNT ? ` (Max: ${MAX_IMG_COUNT})` : ''}` : `Select images`}
                                tooltip={'Allowed files: .jpg, .jpeg, .png'}
                                outlined={true}
                                variant={theme.primaryBlue}
                                bgColor={theme.primaryBlue10}
                                loadingWidth={'auto'}
                                asLoading={isFieldTrue(Fields.imagesLoading)}
                                disabled={isFieldTrue(Fields.imagesLoading) || getArrLen(getFormField(mf.imageList)) > MAX_IMG_COUNT}
                                onClick={() => {
                                    try {
                                        imgChooserInputRef.current.click();
                                    } catch (e) {
                                        toast("Couldn't select images, please try again!", CssVariant.danger);
                                        logErr(e);
                                    }
                                }}
                            />

                            {/*clear-imgs*/}
                            {isImgListFound() && <ThemedButton
                                className={'w-auto px-2 py-1 text-nowrap fs-sm'}
                                text={(isImgListFound() && getFormField(mf.imageList).some(item => isJsonValueTrue(item, 'selected')))
                                    ? `Clear selected images`
                                    : 'Clear all images'}
                                outlined={true}
                                variant={'red'}
                                ml={3}
                                onClick={() => {
                                    const someSelected = isImgListFound() && getFormField(mf.imageList).some(item => isJsonValueTrue(item, 'selected'));
                                    if (window.confirm(`Are you sure you want to clear ${someSelected ? 'selected' : 'all'} images?`)) {
                                        if (someSelected) {
                                            updateFormField(mf.imageList, getFormField(mf.imageList).filter((thisItem) => !isJsonValueTrue(thisItem, 'selected')));
                                        } else {
                                            updateFormField(mf.imageList, []);
                                        }
                                        clearImgInput()
                                    }
                                }}
                            />}

                            {/*count*/}
                            {isImgListFound() && <Label className={'m-0 p-0 px-2 ms-2 text-nowrap fs-smx'} textAt={'start'} color={theme.text70}>
                                {getArrLen(getFormField(mf.imageList).filter(item => isJsonValueTrue(item, 'selected')), 0)}/{getArrLen(getFormField(mf.imageList), 0)}
                            </Label>}
                        </Flexbox>

                        {/*max-count*/}
                        <Label className={'m-0 p-0 px-2 ms-2 text-nowrap fw-semi-bold fs-sm'} textAt={'start'} color={theme.text40} style={{float: 'right'}}>
                            Max limit: {MAX_IMG_COUNT}
                        </Label>
                    </Flexbox>
                    {/*img-grid*/}
                    <div className={'mt-1'}>
                        {isImgListFound()
                            ? <div>
                                {/*select-all*/}
                                <div className={'d-flex w-auto'}>
                                    <Checkbox
                                        wrapperClassName={'w-auto'}
                                        defaultChecked={getFormField(mf.imageList).every(item => isJsonValueTrue(item, 'selected'))}
                                        checked={getFormField(mf.imageList).every(item => isJsonValueTrue(item, 'selected'))}
                                        onChange={(e, value) => {
                                            log('selectAll.cb.onChange.value:', value);
                                            updateFormField(mf.imageList, getFormField(mf.imageList).map((thisItem) => {
                                                return {
                                                    ...thisItem,
                                                    selected: value
                                                }
                                            }));
                                        }}>Select all images</Checkbox>
                                </div>

                                <div className={''}>
                                    <GridBox className={'px-2'} md={3} sm={6} justifyAt={'start'}>
                                        {getFormField(mf.imageList).map((item, index) => {
                                            return <div key={index + 'asdf'}>
                                                <Avatar
                                                    wrapperClassName={'w-100'}
                                                    className={''}
                                                    justifyAt={'center'}
                                                    label={''}
                                                    accept={'.jpg, .jpeg, .png'}
                                                    editTooltip={`Edit (.jpg, .jpeg, .png)`}
                                                    showEdit={false}//Doesn't work properly with backend & may create duplicate, so disabled it: 7Oct2024
                                                    showDelete={true}
                                                    circular={false}
                                                    showFullPreviewDialog={true}
                                                    defAvatarImg={Constants.imgVector}
                                                    showLoading={isFieldTrue(Fields.imagesLoading)}
                                                    editSize={'26px'}
                                                    width={'100%'}
                                                    height={'140px'}
                                                    maxSize={INPUT_FILE_MAX_SIZE}
                                                    componentStart={<div className={'position-absolute'}
                                                                         style={{top: '.4rem', left: '.4rem', zIndex: 1}}>
                                                        {/*select-img*/}
                                                        <Checkbox wrapperClassName={''}
                                                                  className={''}
                                                                  px={0} py={0}
                                                                  defaultChecked={isJsonValueTrue(item, 'selected')}
                                                                  checked={isJsonValueTrue(item, 'selected')}
                                                                  onChange={(e, value) => {
                                                                      log('value:', value, 'item:', item);
                                                                      if (isImgListFound()) {
                                                                          updateFormField(mf.imageList, getFormField(mf.imageList).map((thisItem) => {
                                                                              return {
                                                                                  ...thisItem,
                                                                                  selected: getJsonValue(thisItem, mf.recordId.column) == getJsonValue(item, mf.recordId.column) ? value : isJsonValueTrue(thisItem, 'selected'),
                                                                              }
                                                                          }));
                                                                          clearImgInput()
                                                                      }
                                                                  }}/>
                                                    </div>}
                                                    // component={<div className={'position-absolute bg-infox'}
                                                    //                 style={{top: '1.9rem', right: '-.2rem'}}>
                                                    //     {/*delete img*/}
                                                    //     <ThemedIconButton
                                                    //         className={''}
                                                    //         tooltip={'Delete Image'}
                                                    //         variant={'red'}
                                                    //         bgColor={theme.textWhite}
                                                    //         hoverBgColor={'red'}
                                                    //         outlined={true}
                                                    //         icon={'bi bi bi-trash'}
                                                    //         iconSize={'11px'}
                                                    //         size={'28px'}
                                                    //         loadingVariant={CssVariant.danger}
                                                    //         onClick={() => {
                                                    //             if (isImgListFound()) {
                                                    //                 updateFormField(mf.imageList, getFormField(mf.imageList).filter((thisItem) => getJsonValue(thisItem, mf.recordId.column) != getJsonValue(item, mf.recordId.column)));
                                                    //                 clearImgInput()
                                                    //             }
                                                    //         }}
                                                    //     />
                                                    // </div>}
                                                    onChange={(e, file, path, name, ext) => {
                                                        if (isImgListFound()) {
                                                            updateFormField(mf.imageList, getFormField(mf.imageList).map((thisItem) => {
                                                                if (getJsonValue(thisItem, mf.recordId.column) == getJsonValue(item, mf.recordId.column)) {
                                                                    return {
                                                                        ...thisItem,
                                                                        [mf.title.column]: file,
                                                                        [mf.fileExt.column]: ext,
                                                                    }
                                                                } else {
                                                                    return thisItem;
                                                                }
                                                                clearImgInput()
                                                            }));
                                                        }
                                                    }}
                                                    onDeleteClick={() => {
                                                        if (isImgListFound()) {
                                                            updateFormField(mf.imageList, getFormField(mf.imageList).filter((thisItem) => getJsonValue(thisItem, mf.recordId.column) != getJsonValue(item, mf.recordId.column)));
                                                            clearImgInput()
                                                        }
                                                    }}
                                                    onInvalidFormat={(e, name) => {
                                                        toast(`Invalid file format. File must be jpg, jpeg or png`, CssVariant.danger);
                                                    }}
                                                    onSizeExceeded={() => {
                                                        toast(`Max size exceeded: ${INPUT_FILE_MAX_SIZE}`, CssVariant.danger);
                                                    }}>
                                                    {getJsonValue(item, mf.title.column)}
                                                </Avatar>
                                            </div>
                                        })}
                                    </GridBox>
                                </div>
                            </div>
                            : <NullMsgLabel className={'mt-n1 ms-n1'} color={theme.text40} textAt={'start'}>
                                {'No images found!'}
                            </NullMsgLabel>}
                    </div>
                </div>

                {/* participants cb-list   */}
                <div className={'mt-3'}>
                    {createLabelField(mf.notificationTo.title, true)}

                    {/*participantDisplayType*/}
                    <RadioToggle
                        className={`bg-infox px-3x`}
                        radioClassName={'w-auto'}
                        labelClassName={'fw-semi-bold text-input-label'}
                        labelColor={theme.text40}
                        cbPy={0}
                        required={true}
                        checked={getFormField(mf.participantDisplayType) == PARTICIPANT_TYPES.membersOnly}
                        config={{
                            // label: "Participant Type",
                            active: PARTICIPANT_TYPES.membersOnly,
                            inactive: PARTICIPANT_TYPES.groupsOnly,
                        }}
                        onChange={(e, value) => {
                            // log('participantDisplayType.RadioToggle.onChange.value:', value);
                            updateFormField(mf.participantDisplayType, value);
                        }}
                    />

                    {/*notificationTo*/}
                    <Checkbox
                        wrapperClassName={''}
                        className={''}
                        checkmarkMarginTop={''}
                        labelClassName={''}
                        defaultChecked={isFormFieldTrue(mf.notificationTo)}
                        checked={isFormFieldTrue(mf.notificationTo)}
                        onChange={(e, value) => {
                            updateFormField(mf.notificationTo, value);
                        }}>{"Send Notification Email"}</Checkbox>

                    {/*participants & groups*/}
                    <div className={'px-2'}>
                        {/*groups grid*/}
                        {(getFormField(mf.participantDisplayType) == PARTICIPANT_TYPES.groupsOnly) && <div>
                            {(checkNullArr(getParticipantGroupsList()))
                                ? <GridBox className={'px-3'} sm={12} md={4} gap={0}>
                                    {getParticipantGroupsList().map((cbItem, index) => {
                                        return (checkNullJson(cbItem)) && <Checkbox
                                            key={cbItem[NAME_KEY] + index}
                                            wrapperClassName={''}
                                            className={''}
                                            labelClassName={'fw-semi-bold'}
                                            defaultChecked={getField(Fields.currParticipantGroupId) == cbItem.id}
                                            checked={getField(Fields.currParticipantGroupId) == cbItem.id}
                                            onChange={(e, value) => {
                                                updateField(Fields.currParticipantGroupId, value ? cbItem.id : null);
                                                // log('participantGroupNames.map.cb.onChange.value:', value, 'id:', cbItem.id);

                                                let names = getParticipantGroupsList();
                                                names = names.map((nameItem) => {
                                                    return {
                                                        ...nameItem,
                                                        selected: nameItem[NAME_KEY] == cbItem[NAME_KEY] ? value : isBoolTrue(nameItem.selected),
                                                    }
                                                });
                                                updateFormField(mf.participantGroupNames, names);
                                                // log('participantGroupNames.map.cb.onChange.value:', value, '\nnames:', names);
                                                // log('curr-cbItem.name:', cbItem.name, 'curr-name-found', names.some(item => (isJsonValueTrue(item,'selected'))));
                                            }}
                                        >{cbItem.name}</Checkbox>
                                    })}
                                </GridBox>
                                : createLabelField('No groups found!', false, theme.text, '')}
                        </div>}

                        {/*participant-list*/}
                        <div>
                            <SearchableCheckboxList
                                roundedVariant={4}
                                listHeight={'50vh'}
                                searchPlaceholder={'Search members...'}
                                borderColor={theme.text30}
                                showSelect={false}
                                pad={2}
                                checkListColumnCount={3}
                                showDisplaySelectedOnly={true}
                                isCheckItemJson={true}
                                checkItemJsonIdKey={'id'}
                                checkItemJsonTextKey={'name'}
                                checkDataList={getParticipantList()}
                                onValueChange={(e, value, selectedList) => {
                                    // log('participantNames-searchList.onValueChange.selectedList:', selectedList, 'len:', selectedList.length);
                                    updateFormField(mf.participantNamesSelectedOnly, selectedList);
                                }}
                            />
                        </div>
                    </div>
                </div>

                {/*footer*/}
                <div className={'mt-3'}>
                    {/*msg-box*/}
                    {checkNullStr(getField(Fields.panelMsg)) && <MsgBox color={getField(Fields.panelMsgColor, theme.text)}>
                        {getField(Fields.panelMsg)}
                    </MsgBox>}

                    {/*controls*/}
                    <Flexbox className={'mt-2'} justifyAt={'center'} alignAt={'center'}>
                        <ThemedButton
                            className={'rounded-2 w-auto px-4 py-1'}
                            text={isFieldTrue(Fields.submitBtn_AsLoading)
                                ? isUpdateMode() ? 'Updating...' : 'Uploading...'
                                : isUpdateMode() ? 'Update' : 'Upload'}
                            variant={theme.primaryBlue}
                            hoverBgColor={theme.primaryBlueDark}
                            loadingWidth={'auto'}
                            asLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
                            disabled={isFieldTrue(Fields.submitBtn_disabled)}
                            onClick={handleSubmit}
                        />
                    </Flexbox>
                </div>
            </div>
        </FormPageRoot>
        {createAlbumFormDialog()}
    </>)

    //======================UI Functions start=====================
    function createLabelField(label, required, color = theme.text40, className) {
        return <Label className={`text-input-label m-0 p-0 px-2 pb-1 ${className}`}
                      color={color} textAt={'start'} required={required}>
            {label}
        </Label>
    }

    function createAlbumFormDialog() {
        return <Img_CreateAlbum_FormDialog
            open={isFieldTrue(Fields.openCreateAlbumDialog)}
            onHide={() => {
                // updateField(Fields.openCreateAlbumDialog, false);
            }}
            onCancel={() => {
                updateField(Fields.openCreateAlbumDialog, false);
            }}
            onSuccess={(fetchedData, message) => {
                updateField(Fields.openCreateAlbumDialog, false);
                // log('createAlbumFormDialog.onSuccess.fetchedData:', fetchedData, 'message:', message);
                fetchAlbums();
            }}
        />
    }

    //======================UI Functions end=====================

    //======================Request Functions start=====================
    function handleSubmit() {
        const fun = 'handleSubmit:';
        log(fun, 'formData:', formData);
        if (UnderMaintenance) {
            toast(UnderMaintenanceMsg, CssVariant.warning);
            return false;
        }
        if (!isOnline) {
            toast(internetCheckingMsg, CssVariant.warning);
            return false;
        }

        try {
            let allFieldsChecked = checkRequiredFields();
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);

                const REQUEST_OPTIONS = {
                    updateOnly: isUpdateMode(),
                    recordId: getField(Fields.updateRecordId),
                    browserUrl: window.location.href,
                    formData: formData,
                    subdomainData: getSubdomainSessionData(),
                };
                sendRequest({
                    reqUrl: ReqUrls.img__addEditPage_submit_formData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        // updateField(Fields.submitBtn_disabled, false);//for testing only
                        if (success) {
                            toast(message, CssVariant.success);
                            redirectPage();
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.submitBtn_disabled, false);
                        }
                        updateField(Fields.submitBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        toast(Messages.saveError, CssVariant.danger);
                        updateField(Fields.submitBtn_AsLoading, false);
                        updateField(Fields.submitBtn_disabled, false);
                        logErr(fun, error);
                    }),
                });
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }

    async function fetchParticipantList(selectedIntIds = [], isAddMode) {
        const fun = 'fetchParticipantList:';
        try {
            if (!isFieldTrue(Fields.participantsLoaded)) {
                updateField(Fields.participantsLoaded, true);
                updateField(Fields.participantsLoading, true);
                if (isBoolTrue(isAddMode)) {
                    updateField(Fields.isDataLoading, true);
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.dataLoadingMsg, "");
                }

                const REQUEST_OPTIONS = {};
                sendRequest({
                    reqUrl: ReqUrls.eventForm__fetch_participantsList,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        // log(fun, 'fetchedData:', fetchedData);

                        let members = getJsonValueFromNestedKeys(fetchedData, ['data', 'members'], []);
                        let groups = getJsonValueFromNestedKeys(fetchedData, ['data', 'groups'], []);
                        // log(fun, 'fetchedData.members:', members, 'groups:', groups);

                        //select selectedIntIds by-default
                        // if (isUpdateMode()) log(fun, 'selectedIntIds:', selectedIntIds);
                        if (checkNullArr(members) && checkNullArr(selectedIntIds)) {
                            members = members.map((item) => {
                                return {
                                    ...item,
                                    selected: checkNullArr(selectedIntIds) && selectedIntIds.includes(parseInteger(getJsonValue(item, 'id'), -1))
                                };
                            });
                            updateFormField(mf.participantNamesSelectedOnly, members.filter(filterItem => isJsonValueTrue(filterItem, 'selected')));
                        }

                        updateField(Fields.participantsLoading, false);
                        updateField(Fields.participantsLoaded, true);

                        updateFormField(mf.participantNames, members);
                        updateFormField(mf.participantGroupNames, groups);
                        if (isBoolTrue(isAddMode)) {
                            updateField(Fields.isDataLoading, false);
                            updateField(Fields.isDataFound, true);
                        }
                    }),
                    onError: ((error) => {
                        logErr(fun, error);
                        if (isBoolTrue(isAddMode)) {
                            updateField(Fields.isDataLoading, false);
                            updateField(Fields.isDataFound, true);
                        }
                        updateField(Fields.participantsLoading, false);
                        updateField(Fields.participantsLoaded, true);
                        updateField(Fields.participantsLoadingMsg, "Couldn't load participants!");
                    }),
                });


                if (isBoolTrue(isAddMode)) {
                    fetchAlbums();
                }
            }
        } catch (error) {
            logErr(fun, error);
            if (isBoolTrue(isAddMode)) {
                updateField(Fields.isDataLoading, false);
                updateField(Fields.isDataFound, true);
            }

            updateField(Fields.participantsLoading, false);
            updateField(Fields.participantsLoaded, true);
            updateField(Fields.participantsLoadingMsg, "Couldn't load participants!");
        }
    }

    async function fetchEditModeData(recordId) {
        const fun = 'fetchEditModeData:';
        try {
            log(fun, 'recordId:', recordId, 'isUpdateFormDataFetched:', isFieldTrue(Fields.isUpdateFormDataFetched));

            if (!isFieldTrue(Fields.isUpdateFormDataFetched)) {
                updateField(Fields.isUpdateFormDataFetched, true);
                updateField(Fields.updateRecordId, recordId);
                if (checkNullStr(recordId)) {
                    updateField(Fields.isDataLoading, true);
                    updateField(Fields.dataLoadingMsg, "");

                    //send-request
                    const REQUEST_OPTIONS = {
                        recordId: recordId,
                    };
                    sendRequest({
                        reqUrl: ReqUrls.img__addEditPage_fetch_editFormData,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const fetchedFormData = getJsonValue(fetchedData, 'data', {});
                            const success = checkNullJson(fetchedFormData);

                            updateField(Fields.isDataFound, success);
                            if (success) {
                                // toast('Successfully fetched your data.', CssVariant.success);
                                setFormData(fetchedFormData);

                                //Update participantDisplayType, bcuz it doesn't come from database
                                updateFormField(mf.participantDisplayType, PARTICIPANT_TYPES.membersOnly);

                                //extract participants ids to be by-default selected
                                const prtscptIdsStr = getJsonValue(fetchedFormData, mf.notificationTo.column) + '';
                                // log(fun, 'fetchedData.prtscptIdsStr:', prtscptIdsStr);
                                // if (checkNullStr(prtscptIdsStr)) {
                                const selectedIds = checkNullStr(prtscptIdsStr) ? prtscptIdsStr.split(',').map(item => parseInteger(trim(item), -1)) : [];
                                // log(fun, 'fetchedData.prtscptIdsStr.selectedIds:', selectedIds);
                                fetchParticipantList(selectedIds, false);


                                const albumId = getJsonValue(fetchedFormData, mf.albumId.column);
                                const albumName = getJsonValue(fetchedFormData, mf.albumName.column);
                                fetchAlbums(albumId, albumName);
                            } else {
                                updateField(Fields.dataLoadingMsg, "Invalid record id!");
                            }
                            updateField(Fields.isDataLoading, false);
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } else {
                    updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            }
        } catch (error) {
            logErr(fun, error);
            updateField(Fields.dataLoadingMsg, Messages.fetchError);
            updateField(Fields.isDataFound, false);
            updateField(Fields.isDataLoading, false);
        }
    }

    async function fetchAlbums(selectedId = '', selectedName = '') {
        const fun = 'fetchAlbums:';
        try {
            updateField(Fields.showAlbumLoading, true);
            updateField(Fields.albums, []);
            updateFormField(mf.albumName, null);
            updateFormField(mf.albumId, null);
            // Fetch the albums
            sendRequest({
                reqUrl: ReqUrls.img__fetch_Albums,
                onFetched: ((fetchedData) => {
                    // log(fun, 'doc__fetch_Albums.fetchedData:', fetchedData);
                    const albums = getJsonValue(fetchedData, 'data');
                    const success = checkNullArr(albums);
                    if (success) {
                        updateField(Fields.albums, albums);
                        if (checkNullStr(selectedId)) {
                            updateFormField(mf.albumId, selectedId);
                            updateFormField(mf.albumName, selectedName);
                        }
                        // log(fun, 'doc__fetch_Albums.selectedId:', selectedId, 'selectedName:', selectedName);
                    } else {
                        toast("No albums found, please create a album first from Images Page.", CssVariant.danger);
                    }
                    updateField(Fields.showAlbumLoading, false);
                }),
                onError: ((error) => {
                    toast("Couldn't load albums, please refresh again!", CssVariant.danger);
                    logErr(fun, error);
                    updateField(Fields.showAlbumLoading, false);
                }),
            });
        } catch (error) {
            toast("Couldn't load albums, please refresh again!", CssVariant.danger);
            logErr(error);
            updateField(Fields.showAlbumLoading, false);
        }
    }

    function redirectPage() {
        createTimeout(() => {
            panelLog(`Redirecting you to the '${moduleName}' page now...`);
            createTimeout(() => {
                window.location.href = ModuleRouteUrls[moduleName];
            }, 2500);
        }, 500);
    }

    //======================Request Functions end=====================

    //======================Util Functions start=====================
    function checkRequiredFields() {
        const fun = 'checkRequiredFields:';
        const requiredFields = [
            mf.albumName,
            mf.imageList,
            mf.participantNamesSelectedOnly,
        ];

        let verified = false;
        let colField = {};
        for (const field of requiredFields) {
            if (field.column === mf.participantNamesSelectedOnly.column) {
                // const names = (getJsonValue(formData, field.column));
                // log(fun, "requiredFields.field.participantNames.names:", names);
                if (checkNullArr(getJsonValue(formData, field.column))) {
                    verified = true;
                } else {
                    colField = field;
                    verified = false;
                    break;
                }
            } else if (!checkNullStr(formData[field.column])) {
                colField = field;
                verified = false;
                break;
            }
        }
        if (!verified) {
            // log(fun, "!verified.colField:", colField, 'idToFocus:', colField.column);
            updateFormFieldMsg(colField, 'Required field');
            toast(`'${colField.title}' cannot be empty!`, CssVariant.danger);
            focusIdField(colField.column);
        }
        // log('getParticipantList',getParticipantList());
        return verified;
    }

    function focusIdField(id, onlyFocus = false) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
    }

    function getParticipantList(filtered = true) {
        if (checkNullArr(getFormField(mf.participantNames))) {
            if (getFormField(mf.participantDisplayType) == PARTICIPANT_TYPES.groupsOnly && filtered) {
                const currGroupId = getField(Fields.currParticipantGroupId);
                if (checkNullStr(currGroupId) && checkNullArr(getParticipantGroupsList())) {
                    return getJsonValue(getArrIndexValue(getParticipantGroupsList().filter(item => item.id == currGroupId), 0, {}), 'members', []);
                } else {
                    return [];
                }
            } else {
                return getFormField(mf.participantNames);
            }
        } else {
            return []
        }
    }

    function getParticipantGroupsList() {
        if (checkNullArr(getFormField(mf.participantGroupNames))) {
            return getFormField(mf.participantGroupNames);
        } else {
            return []
        }
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateFormField(clmField, value, direct = false) {
        setFormData(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormField(clmField, defValue, direct = false) {
        return getJsonValue(formData, direct ? clmField : clmField.column, defValue);
    }

    function isFormFieldTrue(clmField, direct = false) {
        return isBoolTrue(getFormField(clmField, null, direct), true, true);
    }

    function updateFormFieldMsg(clmField, value, direct = false) {
        setFormFieldsMsgs(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormFieldMsg(clmField, defValue, direct = false) {
        return getJsonValue(formFieldsMsgs, direct ? clmField : clmField.column, defValue);
    }

    function isImgListFound() {
        return checkNullArr(getFormField(mf.imageList));
    }

    function clearImgInput() {
        try {
            if (imgChooserInputRef.current) {
                imgChooserInputRef.current.value = ""; // Clear the file input
            }
        } catch (error) {
            logErr('clearImgInput.error:', error);
        }
    }

    function isUpdateMode() {
        return isBoolTrue(updateOnly);
    }

    function getTabTitle() {
        return isUpdateMode() ? `Edit Images` : `Upload Images`;
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        log(...[text]);
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default Image_AddEdit_FormPage;
